import React from 'react';
import ReactMarkdown from "react-markdown";
import remarkGfm from 'remark-gfm';

const Message = ({sender, time, ...props}) => {

  console.log(sender)

  var rowClasses = sender === 'IE Chatbot' ? '' : 'justify-end';
  var bubbleClasses = sender == 'IE Chatbot' ? 'bg-lightgrey w-75' : 'bg-red w-75';

  if (sender === 'IE Chatbot') {
    bubbleClasses += ' w-auto'
  }

  return (
    <div className={'message mb-6 flex flex-row ' + props.className + ' ' + rowClasses}>
      <div className={'rounded-[25px] py-4 px-6 inline-flex flex-col ' + bubbleClasses}>
        {!props.className.includes('loader') && <h4>{sender}<span> - {time}</span></h4>}
        {!props.className.includes('loader') && <ReactMarkdown linkTarget="_blank" remarkPlugins={[remarkGfm]} children={props.children}></ReactMarkdown>}
        {props.className.includes('loader') && props.children}
      </div>
    </div>
  );

};

export default Message;
